// src/app/guards/auth.guard.ts

import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

// This is the new functional guard.
export const authGuard: CanActivateFn = (route, state) => {
  // Check the platform ID first.
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    // If we are on the server, there's no user. Block access immediately.
    // The AuthService is NEVER injected or constructed, preventing the crash.
    return false;
  }

  // --- This code only runs in the browser ---
  
  // Now that it's safe, inject the services we need.
  const authService = inject(AuthService);
  const router = inject(Router);

  authService.checkLogin();

  // Return the observable to handle the async login check correctly.
  return authService.isUserLoggedIn.pipe(
    map(isLoggedIn => {
      if (isLoggedIn) {
        return true; // User is logged in, allow access.
      }
      // User is not logged in, redirect them to the home page.
      return router.parseUrl('');
    })
  );
};